/**
 * WebSocket 通知房间 key 规则（与中台 WebSocketRoomKeys 一致）
 */

export function roomKeyForRole(storeId, roleCode) {
  const store = String(storeId || '').trim()
  const role = String(roleCode || process.env.VUE_APP_CLIENT_ROLE || 'yuanqi').trim().toLowerCase()
  if (!store || !role) return ''
  return `STORE_${store}_ROLE_${role}`
}

export function expectedYuanqiRoomKey(storeId) {
  return roomKeyForRole(storeId, process.env.VUE_APP_CLIENT_ROLE || 'yuanqi')
}
